import { GlobalFooter } from "@/patterns/global-footer/src/index";
import StickyContainer from "@/patterns/sticky-container/sticky-container";

import { ParentScrollTracking } from "../../../../utils/scroll-tracking";
import {
    BlogsSection,
    JiraEnhancedAboveNavBanners,
    JiraPlainBanners,
    CTASection,
    DevOpsSection,
    LoggedInHeroSection,
    IntegrationSection,
    ScalingSection,
    TabsSection,
    WorkflowSection
} from "../sections/productionized/logged-in-jira";
import JiraSoftwareNavV2 from "../sections/productionized/software-jira-navbar";

export const LoggedInJiraProductTourOverview = () => {
    return (
        <div>
            <StickyContainer>
                <JiraEnhancedAboveNavBanners />
                <JiraSoftwareNavV2 />
            </StickyContainer>
            <ParentScrollTracking scrollTrackingEnabled={true} pageId="jsw">
                <JiraPlainBanners />
                <LoggedInHeroSection />
                <TabsSection />
                <WorkflowSection />
                <IntegrationSection />
                <DevOpsSection />
                <BlogsSection />
                <ScalingSection />
                <CTASection />
                <GlobalFooter />
            </ParentScrollTracking>
        </div>
    );
};
